import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Protected route for drivers only
 * Checks if user is a driver account or has drive_delivery capability
 */
const DriverRoute = ({ children }) => {
  const { user, loading, canDrive } = useAuth();

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-floral-600 mx-auto"></div>
          <p className="text-floral-600 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to create order if not authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Check if user is a driver (either accountType driver or has drive capability)
  const isDriver = user.accountType === 'driver' || (canDrive && canDrive() && user.driverStatus === 'active');

  // Redirect to orders if user is not a driver
  if (!isDriver) {
    return <Navigate to="/orders" replace />;
  }

  // User is authenticated and is a driver
  return children;
};

export default DriverRoute;
